module.exports = __webpack_public_path__ + "img/SER-i-2-IV.7e4cd0ff.png";